import { State } from 'modules';

export const overview = (state: State) => state.billing.overview;

export const entitlement = (state: State) => state.billing.entitlement;

export const hasCheckDesigner = (state: State) =>
  state.billing.entitlement?.hasCheckDesigner ?? false;

export const hasCustomEmailTemplates = (state: State) =>
  state.billing.entitlement?.hasCustomEmailTemplates ?? false;

export const hasApiAccess = (state: State) =>
  state.billing.entitlement?.hasApiAccess ?? false;

// The entitlement carries no plan code, and the badge is the one thing only the free plan has, so
// it stands in for "on a paid plan".
export const isOnPaidPlan = (state: State) =>
  state.billing.entitlement !== null && !state.billing.entitlement.showBadge;

export const isEntitlementLoaded = (state: State) =>
  state.billing.entitlement !== null;

export const currentPlan = (state: State) =>
  state.billing.overview?.currentPlan ?? null;

export const subscription = (state: State) =>
  state.billing.overview?.subscription ?? null;

export const plans = (state: State) => state.billing.overview?.plans ?? [];

export const packTiers = (state: State) =>
  state.billing.overview?.packTiers ?? [];

export const usage = (state: State) => state.billing.overview?.usage ?? null;

export const packChecks = (state: State) =>
  state.billing.overview?.packChecks ?? 0;

export const packChecksUsed = (state: State) =>
  state.billing.overview?.packChecksUsed ?? 0;

export const bankAccountCount = (state: State) =>
  state.billing.overview?.bankAccountCount ?? 0;

export const isStripeConfigured = (state: State) =>
  state.billing.overview?.isStripeConfigured ?? false;

export const quote = (state: State) => state.billing.quote;

export const purchases = (state: State) => state.billing.purchases;

export const invoices = (state: State) => state.billing.invoices;

export const loadInvoicesPending = (state: State) =>
  state.billing.loadInvoicesPending;

export const loadBillingOverviewPending = (state: State) =>
  state.billing.loadBillingOverviewPending;

export const loadPackQuotePending = (state: State) =>
  state.billing.loadPackQuotePending;

export const loadPurchasesPending = (state: State) =>
  state.billing.loadPurchasesPending;

export const createTopUpCheckoutPending = (state: State) =>
  state.billing.createTopUpCheckoutPending;

export const subscribeToPlanPending = (state: State) =>
  state.billing.subscribeToPlanPending;

export const openBillingPortalPending = (state: State) =>
  state.billing.openBillingPortalPending;

export const cancelSubscriptionPending = (state: State) =>
  state.billing.cancelSubscriptionPending;
